import React from 'react';
import { Card, CardHeader, CardFooter, Text, YStack, XStack, Circle, Button } from 'tamagui'
import { MaterialIcons, Ionicons } from '@expo/vector-icons'
import { LinearGradient } from 'expo-linear-gradient'
import { Platform, Pressable } from 'react-native';

export const WhatsAppTemplateCard = ({ item }) => {
  const { name, components, language, status, category } = item;

  const header = components.find(c => c.type === 'HEADER')?.text
  const body = components.find(c => c.type === 'BODY')?.text
  const footer = components.find(c => c.type === 'FOOTER')?.text

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'APPROVED': return '$green10'
      case 'PENDING': return '$yellow10' 
      case 'REJECTED': return '$red10'
      default: return '$grey10'
    }
  }

  const getStatusIcon = (status: string) => {
    switch (status) {
      case 'APPROVED': return 'check-circle'
      case 'PENDING': return 'schedule'
      case 'REJECTED': return 'cancel'
      default: return 'help'
    }
  }

  const getCategoryIcon = (category: string) => {
    switch (category?.toLowerCase()) {
      case 'marketing': return 'campaign'
      case 'utility': return 'build'
      case 'authentication': return 'verified-user'
      default: return 'message'
    }
  }

  return (
    <Pressable>
      {({ pressed }) => (
        <Card 
          bordered 
          width={320} 
          height={280}
          minHeight={350}
          elevate 
          size="$4" 
          padding="$0"
          borderRadius="$8" 
          theme="light"
          backgroundColor="$background"
          borderColor="$borderColor"
          borderWidth={1}
          shadowColor="$shadowColor"
          shadowOffset={{ width: 0, height: 4 }}
          shadowOpacity={0.15}
          shadowRadius={12}
          transform={[{ scale: pressed ? 0.98 : 1 }]}
          animation="quick"
        >
          {/* Header with gradient background */}
          <LinearGradient
            colors={['#25D366', '#128C7E']}
            start={{ x: 0, y: 0 }}
            end={{ x: 1, y: 0 }}
            style={{
              borderTopLeftRadius: 16,
              borderTopRightRadius: 16,
              padding: 16,
            }}
          >
            <CardHeader padding="$0">
              <XStack justifyContent="space-between" alignItems="center">
                <YStack flex={1} space="$2">
                  <Text 
                    fontSize="$6" 
                    fontWeight="700" 
                    color="white"
                    numberOfLines={1}
                  >
                    {name}
                  </Text>
                  <XStack space="$2" alignItems="center">
                    <MaterialIcons 
                      name={getCategoryIcon(category)} 
                      size={14} 
                      color="rgba(255,255,255,0.8)" 
                    />
                    <Text 
                      fontSize="$2" 
                      color="rgba(255,255,255,0.8)"
                      textTransform="uppercase"
                    >
                      {category} • {language}
                    </Text>
                  </XStack>
                </YStack>
                <Circle 
                  size="$3" 
                  backgroundColor="rgba(255,255,255,0.2)"
                  justifyContent="center"
                  alignItems="center"
                >
                  <MaterialIcons 
                    name="chat" 
                    size={20} 
                    color="white" 
                  />
                </Circle>
              </XStack>
            </CardHeader>
          </LinearGradient>

          {/* Content Section */}
          <YStack space="$3" padding="$4" flex={1}>
            {header && (
              <YStack space="$1">
                <XStack alignItems="center" space="$2">
                  <MaterialIcons name="title" size={16} color="#666" />
                  <Text fontSize="$3" fontWeight="600" color="$grey11">HEADER</Text>
                </XStack>
                <Text numberOfLines={2} fontSize="$4" fontWeight="600" color="$color">
                  {header}
                </Text>
              </YStack>
            )}
            
            {body && (
              <YStack space="$1">
                <XStack alignItems="center" space="$2">
                  <MaterialIcons name="description" size={16} color="#666" />
                  <Text fontSize="$3" fontWeight="600" color="$grey11">BODY</Text>
                </XStack>
                <Text numberOfLines={3} fontSize="$4" lineHeight="$1" color="$color">
                  {body}
                </Text>
              </YStack>
            )}
            
            {footer && (
              <YStack space="$1">
                <XStack alignItems="center" space="$2">
                  <MaterialIcons name="note" size={16} color="#666" />
                  <Text fontSize="$3" fontWeight="600" color="$grey11">FOOTER</Text>
                </XStack>
                <Text fontSize="$3" fontStyle="italic" numberOfLines={1} color="$grey10">
                  {footer}
                </Text>
              </YStack>
            )}
          </YStack>

          {/* Modern Status Footer */}
          <CardFooter 
            backgroundColor="$grey2" 
            borderBottomLeftRadius="$8"
            borderBottomRightRadius="$8"
            padding="$3"
          >
            <XStack justifyContent="space-between" alignItems="center" flex={1}>
              <XStack alignItems="center" space="$2">
                <MaterialIcons 
                  name={getStatusIcon(status)} 
                  size={18} 
                  color={status === 'APPROVED' ? '#10B981' : status === 'PENDING' ? '#F59E0B' : '#EF4444'} 
                />
                <Text
                  fontSize="$3"
                  color={status === 'APPROVED' ? '$green10' : status === 'PENDING' ? '$yellow10' : '$red10'}
                  fontWeight="700"
                  textTransform="uppercase"
                >
                  {status}
                </Text>
              </XStack>
              
              <Button
                size="$2"
                chromeless
                circular
                icon={<Ionicons name="chevron-forward" size={16} color="#666" />}
                backgroundColor="$grey4"
                pressStyle={{ backgroundColor: '$grey6' }}
                onPress={() => {
                  // Handle template action
                  console.log('Template action:', name);
                }}
              />
            </XStack>
          </CardFooter>
        </Card>
      )}
    </Pressable>
  )
}
